module.exports = __webpack_public_path__ + "static/media/droplets.e2b860a2.webp";